import { useState } from "react"

import translationData from '../translations.json'

type Translations = Record<
    'pl' | 'en',
    {
        createPalleteTitle: string;
        createPalleteSubtitle: string;
        createInputPlaceholder: string;
    }
>

export const useTranslation = () => {

    const [language, setLanguage] = useState<'pl' | 'en'>('pl');
    const translations = translationData as Translations;
    const lang = translations[language];

    return lang;
}